import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-elevation-section',
    templateUrl: './elevation-section.component.html',
    styleUrls: ['./elevation-section.component.css']
})
export class ElevationSectionComponent {
    @Input() title: string;
    @Input() hasShowButton = false;
    @Input() hasAddButton = false;
    @Input() hasEditButton = false;
    @Input() removeMargin = false;
    @Input() initialHeight = true;
    @Input() addButtonDisabled = false;
    @Input() editButtonDisabled = false;
    @Input() removePadding = false; 
    @Output() showClicked = new EventEmitter<void>();
    @Output() addClicked = new EventEmitter<void>();
    @Output() editClicked = new EventEmitter<void>();
    showHR = true;

    constructor(public languageService: LanguageService, private configService: ConfigService) {
      this.showHR = !this.configService.version?.isd24;
    }

    onAddClicked() {
      this.addClicked.emit();
    }

    onEditClicked() {
      this.editClicked.emit();
    }

    onShowClicked() {
        this.showClicked.emit();
    }
}
